import React, { useCallback, useState } from 'react';

import debounce from '@utils/debounce';
import { SearchProps } from '../../interfaces';
import { SearchContainer, SearchBar } from './styles';

const Search: React.FC<SearchProps> = ({
  searchText,
  setSearchText,
  searchKey,
  initialItems,
  setData,
}) => {
  const [debouncedFilterItems] = useState(() => {
    return debounce(async (text: string) => {
      filterItems(text);
    }, 500);
  });

  const filterItems = useCallback(
    (text: string) => {
      if (
        searchKey &&
        text &&
        text !== '' &&
        initialItems &&
        initialItems.length > 0
      ) {
        const newTableItems = initialItems.filter((item) => {
          if (item[searchKey]) {
            if (
              item[searchKey].value
                .toString()
                .toLowerCase()
                .includes(text.toLowerCase())
            ) {
              return item;
            }
          }
          return null;
        });
        setData(newTableItems);
      } else setData(initialItems);
    },
    [searchKey, initialItems, setData],
  );

  const onChangeText = useCallback(
    (value: string) => {
      setSearchText(value);
      debouncedFilterItems(value);
    },
    [setSearchText, debouncedFilterItems],
  );

  return (
    <SearchContainer>
      <SearchBar
        placeholder="Buscar"
        onChange={({ target: { value } }) => onChangeText(value)}
        value={searchText}
      />
    </SearchContainer>
  );
};

export default Search;
